import { useTranslation } from "react-i18next";

export default function AboutSection() {
  const { t } = useTranslation();

  return (
    <section id="about" className="py-16 md:py-20 px-6 md:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-14 items-center">
          <div className="order-2 lg:order-1">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/5]">
              <img
                src="https://readdy.ai/api/search-image?query=Minimal%20modern%20desk%20setup%20featuring%20an%20open%20laptop%20displaying%20colorful%20spreadsheet%20charts%2C%20a%20ceramic%20coffee%20cup%20beside%20it%2C%20warm%20cream%20textured%20wall%20background%2C%20soft%20natural%20daylight%20from%20large%20unseen%20window%2C%20cozy%20productive%20atmosphere%2C%20Scandinavian%20workspace%20aesthetic%2C%20clean%20organized%20desktop%20with%20subtle%20plant%20detail%2C%20editorial%20interior%20photography&width=900&height=1125&seq=about-v2-workspace&orientation=portrait"
                alt="OOPBuy Spreadsheet workspace"
                className="w-full h-full object-cover"
                loading="lazy"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/50 to-transparent p-5">
                <p className="text-background-50/90 text-xs md:text-sm font-medium">{t("about.trust.label")}</p>
                <p className="text-background-50/70 text-xs mt-1">{t("about.trust.text")}</p>
              </div>
            </div>
          </div>

          <div className="order-1 lg:order-2">
            <p className="text-xs md:text-sm text-foreground-500 font-medium tracking-widest uppercase mb-3">
              {t("about.label")}
            </p>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 leading-tight mb-5">
              {t("about.title")}
            </h2>

            <div className="space-y-4 text-sm md:text-base text-foreground-700 leading-relaxed">
              <p>{t("about.p1")}</p>
              <p>{t("about.p2")}</p>
              <p>{t("about.p3")}</p>
            </div>

            <ul className="mt-6 space-y-3">
              <li className="flex items-start gap-3 text-sm md:text-base text-foreground-700">
                <span className="w-5 h-5 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mt-0.5 flex-shrink-0">
                  <i className="ri-check-line text-xs"></i>
                </span>
                {t("about.bullet1")}
              </li>
              <li className="flex items-start gap-3 text-sm md:text-base text-foreground-700">
                <span className="w-5 h-5 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mt-0.5 flex-shrink-0">
                  <i className="ri-check-line text-xs"></i>
                </span>
                {t("about.bullet2")}
              </li>
              <li className="flex items-start gap-3 text-sm md:text-base text-foreground-700">
                <span className="w-5 h-5 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mt-0.5 flex-shrink-0">
                  <i className="ri-check-line text-xs"></i>
                </span>
                {t("about.bullet3")}
              </li>
              <li className="flex items-start gap-3 text-sm md:text-base text-foreground-700">
                <span className="w-5 h-5 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mt-0.5 flex-shrink-0">
                  <i className="ri-check-line text-xs"></i>
                </span>
                {t("about.bullet4")}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}